import React, { useEffect, useRef, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from '../../components/Header';
import Nav from '../../components/Nav';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getDelivryNotes } from '../../redux/actions/delivry_note.action';
import { dateFormat, endpoint, endpointApi } from '../../utils';
import SearchOrder from '../../components/SearchOrder';
import Paginate from '../../components/Paginate';
import { setLoading } from '../../redux/actions/loader.action';
import axios from 'axios';
import { logout } from '../../redux/actions/auth.action';

export default function DelivryNotesPage() {
    const jwt_access = localStorage.getItem('jwt_access');
    const delivryNotes = useSelector(state => state.delivryNotes);
    const { me } = useSelector(state => state.auth);
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [actionModal, setActionModal] = useState(null);
    
    const addModalRef = useRef(null);
    const updateModalRef = useRef(null);
    const detailsModalRef = useRef(null);
    const addFormRef = useRef(null);
    const updateFormRef = useRef(null);
    const [modal, setModal] = useState(null);

    const [delivryNote, setDelivryNote] = useState(null);
    const [order, setOrder] = useState(null);

    const [code, setCode] = useState("");
    const [delivryNoteDate, setDelivryNoteDate] = useState("");
    const [delivryNoteAddress, setDelivryNoteAddress] = useState("");
    const [delivryNoteStatus, setDelivryNoteStatus] = useState("");
    const [orderCode, setOrderCode] = useState("");

    const [isCodeTouched, setIsCodeTouched] = useState(false);
    const [isDelivryNoteDateTouched, setIsDelivryNoteDateTouched] = useState(false);
    const [isDelivryNoteAddressTouched, setIsDelivryNoteAddressTouched] = useState(false);
    const [isDelivryNoteStatusTouched, setIsDelivryNoteStatusTouched] = useState(false);
    const [isOrderCodeTouched, setIsOrderCodeTouched] = useState(false);

    const [errors, setErrors] = useState(null);

    useEffect(() => {
        dispatch(getDelivryNotes(location, navigate));
    }, [location, navigate, dispatch]);

    useEffect(() => {
        const clickOutsideActionModal = (e) => {
            const $actionModals = document.querySelectorAll('.actions>ul');
            $actionModals.forEach($actionModal => {
                if($actionModal && !$actionModal.contains(e.target) && $actionModal.classList.contains('active')){
                    setActionModal(null);
                }
            });
        }
        document.addEventListener('click', clickOutsideActionModal);
        return () => {
            document.removeEventListener('click', clickOutsideActionModal);
        }
    }, []);

    useEffect(() => {
        if(modal !== 'update'){
            if(addFormRef.current)
                addFormRef.current.reset();
            if(updateFormRef.current && modal === null){
                updateFormRef.current.reset();
                setDelivryNote(null);
            }

            setOrder(null);
            setCode("");
            setDelivryNoteDate("");
            setDelivryNoteAddress("");
            setDelivryNoteStatus("");
            setOrderCode("");
            setIsCodeTouched(false);
            setIsDelivryNoteDateTouched(false);
            setIsDelivryNoteAddressTouched(false);
            setIsDelivryNoteStatusTouched(false);
            setIsOrderCodeTouched(false);
            setErrors(null);
        }
    }, [modal]);
    
    useEffect(() => {
        if(modal === "update" && delivryNote){
            setOrder(delivryNote.order);
            setCode(delivryNote.code);
            setOrderCode(delivryNote.order_code ? delivryNote.order_code : '');
            setDelivryNoteDate(delivryNote.date);
            setDelivryNoteAddress(delivryNote.address);
            setDelivryNoteStatus(delivryNote.status);
        }
    }, [modal, delivryNote]);

    useEffect(() => {
        const clickModalOutside = (e) => {
            if((addModalRef.current && addModalRef.current === e.target && addModalRef.current.classList.contains('active')) || (detailsModalRef.current && detailsModalRef.current === e.target && detailsModalRef.current.classList.contains('active')) || (updateModalRef.current && updateModalRef.current === e.target && updateModalRef.current.classList.contains('active')))
                setModal(null);
        }

        document.addEventListener('click', clickModalOutside);
        return () => {
            document.removeEventListener('click', clickModalOutside);
        }
    }, []);

    const handleSubmitAdd = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);
        await axios.post(`${ endpointApi }delivry-notes`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${ jwt_access }`
                        }            
                    })
                    .then(({ data }) => {
                        dispatch(getDelivryNotes(location, navigate));
                        setDelivryNote(data);
                        setModal("details");
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                            const $modals = document.querySelectorAll('._modal-content');
                            $modals.forEach($modal => {
                                $modal.scrollTop = 0;
                            });
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }

    const handleSubmitUpdate = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);
        await axios.put(`${ endpointApi }delivry-notes/${ delivryNote?.id }`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${ jwt_access }`
                        }            
                    })
                    .then(({ data }) => {
                        dispatch(getDelivryNotes(location, navigate));
                        setDelivryNote(data);
                        setModal("details");
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                            const $modals = document.querySelectorAll('._modal-content');
                            $modals.forEach($modal => {
                                $modal.scrollTop = 0;
                            });
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }

    useEffect(() => {
        if(!jwt_access){
            navigate('/login?redirect_to=' + location.pathname + location.search);
        }
    }, [location, navigate, jwt_access]);

    return (
        me &&
        <HelmetProvider>
            <Helmet>
                <title>Bons de livraison - Société Mikalo</title>
            </Helmet>

            <Header />

            <Nav />

            <main id="main">
                <div className='title d-flex justify-content-between'>
                    <h1>Bons de livraison</h1>
                    <button type='button' className='btn btn-primary' onClick={ () => {
                        setModal("add");
                    }}><i className='fa fa-plus'></i> Créer</button>
                </div>

                <div ref={ addModalRef } className={ `_modal${ modal === 'add' ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            <h4>Créer un bon de livraison</h4>
                            <button type='button' className='_modal-close' onClick={ () => setModal(null)}>&times;</button>
                        </div>
                        <div className='_modal-body'>
                            <form ref={ addFormRef } className='form' onSubmit={ handleSubmitAdd }>
                                { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                                <h6>Commande</h6>
                                <div className='mb-3'>
                                    <label htmlFor='order_id' className='required'>N° de commande</label>
                                    <input type='hidden' name='order_id' className='form-control' value={ order ? order.id : "" } />
                                    <SearchOrder required={ true } reset={ modal !== "add" } updateOrder={ setOrder } defaultValue={ order } />
                                    { errors && errors.order_id && <div className='form-error'>{ errors.order_id }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='order_code' className='required'>Code commande</label>
                                    <input type='text' id='order_code' name='order_code' placeholder='Code commande' required className='form-control' value={ orderCode } onChange={ (e) => setOrderCode(e.target.value) } onBlur={ () => setIsOrderCodeTouched(true) } />
                                    { isOrderCodeTouched && orderCode.length === 0 && <div className='form-error'>Veuillez saisir le code commande.</div> }
                                    { errors && errors.order_code && <div className='form-error'>{ errors.order_code }</div> }
                                </div>

                                <h6>Bon de livraison</h6>
                                
                                <div className='mb-3'>
                                    <label htmlFor='delivry_note_date' className='required'>Date de livraison</label>
                                    <input type='date' id='delivry_note_date' name='delivry_note_date' required className='form-control' value={ delivryNoteDate } onChange={ (e) => setDelivryNoteDate(e.target.value) } onBlur={ () => setIsDelivryNoteDateTouched(true) } />
                                    { isDelivryNoteDateTouched && delivryNoteDate.length === 0 && <div className='form-error'>Veuillez saisir la date livraison.</div> }
                                    { errors && errors.delivry_note_date && <div className='form-error'>{ errors.delivry_note_date }</div> }
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='delivry_note_address' className='required'>Adresse de livraison</label>
                                    <input type='text' id='delivry_note_address' name='delivry_note_address' autoComplete='off' placeholder='Adresse de livraison' className='form-control' value={ delivryNoteAddress } onChange={ (e) => setDelivryNoteAddress(e.target.value) } onBlur={ () => setIsDelivryNoteAddressTouched(true) } />
                                    { isDelivryNoteAddressTouched && delivryNoteAddress.length === 0 && <div className='form-error'>Veuillez saisir l'adresse de livraison.</div> }
                                    { isDelivryNoteAddressTouched && delivryNoteAddress.length > 0 && delivryNoteAddress.length < 2 && <div className='form-error'>L'adresse de livraison est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                    { errors && errors.delivry_note_address && <div className='form-error'>{ errors.delivry_note_address }</div> }
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='delivry_note_status' className='required'>Etat de livraison</label>
                                    <select id='delivry_note_status' name='delivry_note_status' required className='form-control' value={ delivryNoteStatus } onChange={ (e) => setDelivryNoteStatus(e.target.value) } onBlur={ () => setIsDelivryNoteStatusTouched(true) }>
                                        <option value="">Sélectionner...</option>
                                        <option value="Pending">En attente</option>
                                        <option value="Shipped">Expédié</option>
                                        <option value="Delivered">Livré</option>
                                        <option value="Failed">Echec de la livraison</option>
                                        <option value="Cancelled">Annulé</option>
                                        <option value="PartiallyDelivered">Partielement livré</option>
                                    </select>
                                    { isDelivryNoteStatusTouched && delivryNoteStatus.length === 0 && <div className='form-error'>Veuillez sélectionner l'état de livraison.</div> }
                                    { errors && errors.delivry_note_status && <div className='form-error'>{ errors.delivry_note_status }</div> }
                                </div>

                                <div className='pt-2 text-end'>
                                    <button type='submit' className='btn btn-lg btn-primary' disabled={
                                        order === null || delivryNoteDate.length === 0 || delivryNoteAddress.length === 0 || delivryNoteStatus.length === 0 || orderCode.length === 0
                                    }><i className="fa fa-save"></i> Enregistrer</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div ref={ detailsModalRef } className={ `_modal${ modal === 'details' && delivryNote ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            { delivryNote &&
                            <h4>{ delivryNote.code }</h4> }
                            <button type='button' className='_modal-close' onClick={ () => setModal(null) }>&times;</button>
                        </div>
                        <div className='_modal-body'>
                            { delivryNote && <>
                            <div className='mb-3'>
                                <div className='_label'>Code</div>
                                <div className='_value'>{ delivryNote.code }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Client</div>
                                <div className='_value'>
                                    { delivryNote && delivryNote.order && delivryNote.order.client ? (delivryNote.order.client.type === "Company" ? delivryNote.order.client.company_name : delivryNote.order.client.last_name + " " + delivryNote.order.client.first_name) : '-' }
                                    <br/>
                                    { delivryNote && delivryNote.order && delivryNote.order.client ? delivryNote.order.client.address + ", " + delivryNote.order.client.zipcode + " " + delivryNote.order.client.city + ", " + delivryNote.order.client.country : "-" }
                                    <br/>
                                    { delivryNote && delivryNote.order && delivryNote.order.client ? (delivryNote.order.client.email ? "E-mail: " : "") + delivryNote.order.client.email + (delivryNote.order.client.phone ? (delivryNote.order.client.email ? " - Tél: " : "Tél: ") + delivryNote.order.client.phone : "") + (delivryNote.order.client.website ? (delivryNote.order.client.email || delivryNote.order.client.phone ? " - Site web: " : "Site web: ") + delivryNote.order.client.website : "") : "-" }
                                </div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Date de livraison</div>
                                <div className='_value'>{ dateFormat(delivryNote.date) }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Code commande</div>
                                <div className='_value'>{ delivryNote.order_code ? delivryNote.order_code : '-' }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Adresse de livraison</div>
                                <div className='_value'>{ delivryNote.address }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Produits à livrer</div>
                                <div className='_value'>
                                    <table className='table table-striped'>
                                        <thead>
                                        <tr>
                                            <th>Nom du produit</th>
                                            <th>Quantité</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        { delivryNote.items.map((item, index) => {
                                            return(
                                            <tr key={ index }>
                                                <td>{ item.product.code } - { item.product.name } - { item.product.subtitle }</td>
                                                <td>{ item.quantity }{ item.product.unit ? ' ' + (item.product.unit === 'Item' ? 'pièce' : (item.product.unit === 'Box' ? 'boîte' : 'carton')) + (item.quantity > 1 ? 's' : '') : '' }</td>
                                            </tr>
                                            )
                                        }) }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Etat</div>
                                <div className='_value'>{ delivryNote.status === "Shipped" ? <span className="badge bg-info">Expédié</span> : (delivryNote.status === "Delivered" ?  <span className="badge bg-success">Livré</span> : (delivryNote.status === "Failed" ? <span className="badge bg-danger">Echec de la livraison</span> : (delivryNote.status === "Cancelled" ? <span className="badge bg-dark">Annulé</span> : (delivryNote.status === "PartiallyDelivered" ? <span className="badge bg-info">Partielement livré</span> : <span className="badge bg-warning">En attente</span> )))) }</div>
                            </div>
                            <div className='text-center pt-2'>
                                <a href={ `${ endpoint }delivry-note/${ delivryNote.id }/download` } target='_blank' rel="noreferrer" className='btn btn-lg btn-orange me-3' onClick={ () => setModal("edit") }><i className='fa fa-download'></i> Télécharger</a>
                                <button type='button' className='btn btn-lg btn-primary' onClick={ () => setModal('update') }><i className="fa fa-edit"></i> Modifier</button>
                            </div>
                            </> }
                        </div>
                    </div>
                </div>

                <div ref={ updateModalRef } className={ `_modal${ modal === 'update' && delivryNote ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            <h4>Modifier un bon de livraison</h4>
                            <button type='button' className='_modal-close' onClick={ () => setModal(null) }>&times;</button>
                        </div>
                        <div className='_modal-body'>
                        { delivryNote && <>
                            <form ref={ updateFormRef } className='form' onSubmit={ handleSubmitUpdate }>
                                { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                                <div className='mb-3'>
                                    <label htmlFor='code' className='required'>Code</label>
                                    <input type='text' id='code' name='code' placeholder='Code' required className='form-control' value={ code } onChange={ (e) => setCode(e.target.value) } onBlur={ () => setIsCodeTouched(true) } />
                                    { isCodeTouched && code.length === 0 && <div className='form-error'>Veuillez saisir le code bon de livraison.</div> }
                                    { isCodeTouched && code.length > 0 && /^BL\/\d{4}\/\d{4,}$/.test(code) === false && <div className='form-error'>Le code bon de livraison n'est pas valide. Le format valide est: BL/[année]/[numéro d'ordre].</div> }
                                    { errors && errors.date && <div className='form-error'>{ errors.date[0] }</div> }
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='_order_code' className='required'>Code commande</label>
                                    <input type='text' id='order_code' name='order_code' placeholder='Code commande' required className='form-control' value={ orderCode } onChange={ (e) => setOrderCode(e.target.value) } onBlur={ () => setIsOrderCodeTouched(true) } />
                                    { isOrderCodeTouched && order.length === 0 && <div className='form-error'>Veuillez saisir le code commande.</div> }
                                    { errors && errors.order_code && <div className='form-error'>{ errors.order_code }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='_delivry_note_date' className='required'>Date de livraison</label>
                                    <input type='date' id='_delivry_note_date' name='date' required className='form-control' value={ delivryNoteDate } onChange={ (e) => setDelivryNoteDate(e.target.value) } onBlur={ () => setIsDelivryNoteDateTouched(true) } />
                                    { isDelivryNoteDateTouched && delivryNoteDate.length === 0 && <div className='form-error'>Veuillez saisir la date livraison.</div> }
                                    { errors && errors.date && <div className='form-error'>{ errors.date[0] }</div> }
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='_delivry_note_address' className='required'>Adresse de livraison</label>
                                    <input type='text' id='_delivry_note_address' name='address' placeholder='Adresse de livraison' className='form-control' value={ delivryNoteAddress } onChange={ (e) => setDelivryNoteAddress(e.target.value) } onBlur={ () => setIsDelivryNoteAddressTouched(true) } />
                                    { isDelivryNoteAddressTouched && delivryNoteAddress.length === 0 && <div className='form-error'>Veuillez saisir l'adresse de livraison.</div> }
                                    { isDelivryNoteAddressTouched && delivryNoteAddress.length > 0 && delivryNoteAddress.length < 2 && <div className='form-error'>L'adresse de livraison est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                    { errors && errors.address && <div className='form-error'>{ errors.address[0] }</div> }
                                </div>

                                <div className='mb-3'>
                                    <div className='_label'>Produits à livrer</div>
                                    <div className='_value'>
                                        <table className='table table-striped'>
                                            <thead>
                                                <tr>
                                                    <th>Nom du produit</th>
                                                    <th>Quantité</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            { delivryNote.items.map((item, index) => {
                                                return(
                                                <tr key={ index }>
                                                    <td>{ item.product.code } - { item.product.name } - { item.product.subtitle }</td>
                                                    <td>{ item.quantity }{ item.product.unit ? ' ' + (item.product.unit === 'Item' ? 'pièce' : (item.product.unit === 'Box' ? 'boîte' : 'carton')) + (item.quantity > 1 ? 's' : '') : '' }</td>
                                                </tr>
                                                )
                                            }) }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='_delivry_note_status' className='required'>Etat de livraison</label>
                                    <select id='_delivry_note_status' name='status' required className='form-control' value={ delivryNoteStatus } onChange={ (e) => setDelivryNoteStatus(e.target.value) } onBlur={ () => setIsDelivryNoteStatusTouched(true) }>
                                        <option value="">Sélectionner...</option>
                                        <option value="Pending">En attente</option>
                                        <option value="Shipped">Expédié</option>
                                        <option value="Delivered">Livré</option>
                                        <option value="Failed">Echec de la livraison</option>
                                        <option value="Cancelled">Annulé</option>
                                        <option value="PartiallyDelivered">Partielement livré</option>
                                    </select>
                                    { isDelivryNoteStatusTouched && delivryNoteStatus.length === 0 && <div className='form-error'>Veuillez sélectionner l'état de livraison.</div> }
                                    { errors && errors.status && <div className='form-error'>{ errors.status[0] }</div> }
                                </div>

                                <div className='pt-2 text-end'>
                                    <button type='submit' className='btn btn-lg btn-primary' disabled={
                                        code.length === 0 || delivryNoteDate.length === 0 || delivryNoteAddress.length === 0 || delivryNoteStatus.length === 0 || orderCode.length === 0 ||
                                        (modal === "update" && delivryNote && code === delivryNote.code && delivryNoteDate === delivryNote.date && delivryNoteAddress === delivryNote.address && delivryNoteStatus === delivryNote.status && delivryNote.order_code === orderCode)
                                    }><i className="fa fa-save"></i> Mettre à jour</button>
                                </div>
                            </form>
                        </> }
                        </div>
                    </div>
                </div>
                
                <div className='box'>
                    <table className='table table-striped'>
                        <thead>
                            <tr>
                                <th width="100">Code</th>
                                <th>Client</th>
                                <th width="160">Date de livraison</th>
                                <th>Adresse de livraison</th>
                                <th width="120">Statut</th>
                                <th width="75" className="text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            { delivryNotes.loading && <tr><td colSpan={ 6 }>Chargement...</td></tr> }
                            { delivryNotes.loading === false && delivryNotes.data && delivryNotes.data.total === 0 && <tr><td colSpan={ 6 }>Aucun élément trouvé</td></tr> }
                            { delivryNotes.loading === false && delivryNotes.data && delivryNotes.data.data && delivryNotes.data.data.map((item, index) => {
                            return (
                            <tr key={ index }>
                                <td>{ item.code }</td>
                                <td>{ item.order && item.order.client ? (item.order.client.type === 'Company' ? item.order.client.company_name : item.order.client.last_name + " " + item.order.client.first_name) : 'Non renseigné' }</td>
                                <td>{ dateFormat(item.date) }</td>
                                <td>{ item.address }</td>
                                <td>
                                    { item.status === "Shipped" ? <span className="badge bg-info">Expédié</span> : (item.status === "Delivered" ?  <span className="badge bg-success">Livré</span> : (item.status === "Failed" ? <span className="badge bg-danger">Echec de la livraison</span> : (item.status === "Cancelled" ? <span className="badge bg-dark">Annulé</span> : (item.status === "PartiallyDelivered" ? <span className="badge bg-info">Partielement livré</span> : <span className="badge bg-warning">En attente</span> )))) }
                                </td>
                                <td className="text-end">
                                    <div className='actions'>
                                        <button type='button' className='toggle-action' onClick={ (e) => {
                                            e.stopPropagation();
                                            setActionModal(actionModal !== item.id ? item.id : null);
                                        } }><i className='fa fa-ellipsis-v'></i></button>
                                        <ul className={ actionModal === item.id ? 'active' : '' }>
                                            <li><button type='button' onClick={ () => {
                                                setActionModal(null);
                                                setDelivryNote(item);
                                                setModal("details");
                                            } }><i className='fa fa-eye'></i> Voir les détails</button></li>
                                            <li><a href={ `${ endpoint }delivry-note/${ item.id }/download` } target='_blank' rel="noreferrer" onClick={ () => {
                                                setActionModal(null);
                                            } }><i className='fa fa-download'></i> Télécharger</a></li>
                                            <li><button type='button' onClick={ () => {
                                                setActionModal(null);
                                                setDelivryNote(item);
                                                setModal("update");
                                            } }><i className='fa fa-edit'></i> Modifier</button></li>
                                        </ul>
                                    </div>
                                </td>
                            </tr> ) })}
                        </tbody>
                    </table>
                </div>
                
                { delivryNotes && delivryNotes.data &&
                <Paginate currentPage={ delivryNotes.data.current_page } totalPages={ delivryNotes.data.last_page } pathname={ location.pathname } search={ location.search } /> }
            </main>
        </HelmetProvider>
    )
}
